import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface Args {
  name: string;
  roomId: string;
  start: Date;
  end: Date;
}

export interface RawResult {
  createTelKey: { name: string; code: string; tel: string };
}

export const createTelKey = async <V>(
  apollo: DollarApollo<V>,
  args: Args
): Promise<FetchResult<RawResult>> => {
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: {
      name: args.name,
      roomId: args.roomId,
      start: Math.floor(args.start.getTime() / 1000),
      end: Math.floor(args.end.getTime() / 1000)
    },
    update(_proxy, data): { code: string; tel: string } {
      return data.data!.createTelKey;
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
